import React, { useContext } from 'react'
import { Trans } from '@lingui/macro'

import { ButtonClean, ButtonPrimary } from 'front-end/src/components'
import { Modal } from '../../../../components/common/modal/Modal'

import './SurveySendPublishModal.less'
import { ManageSurveyContext } from '../ManageSurveyContext'
import IconLock from 'front-end/src/components/common/icon/IconLock'
import { usePublishMutation } from './surveysOperations.codegen'

interface ISurveySendPublishModalProps {
  show: boolean
  onCancel: () => void
  setShowSendModal: (value: boolean) => void
}

export const SurveySendPublishModal = ({
  show,
  onCancel,
  setShowSendModal
}: ISurveySendPublishModalProps) => {
  const { survey, refetchSurvey } = useContext(ManageSurveyContext)
  const [publishSurvey, { loading }] = usePublishMutation()

  return (
    <>
      <Modal
        show={show}
        onHidden={onCancel}
        controls={
          <>
            <ButtonClean onClick={onCancel}>
              <Trans>Cancel</Trans>
            </ButtonClean>
            <ButtonPrimary
              onClick={async () => {
                const { data } = await publishSurvey({
                  variables: {
                    surveyId: survey.id
                  }
                })

                if (data?.admin.survey.publish) {
                  await refetchSurvey()
                  onCancel()
                  setShowSendModal(true)
                }
              }}
              disabled={loading}
              isLoading={loading}
              leftIcon={<IconLock />}
            >
              <Trans>Lock survey</Trans>
            </ButtonPrimary>
          </>
        }
        className="SurveySendPublishModal"
      >
        <div className="Modal__header">
          <div className="SurveySendPublishModal__icon">
            <i className="icon-lock" />
          </div>
          <h3>
            <Trans>Lock survey</Trans>?
          </h3>
        </div>
        <p>
          <Trans>
            In order to send the survey you need to{` `}
            <strong>lock editing</strong> content of the survey first.
          </Trans>
        </p>
      </Modal>
    </>
  )
}
